const authenticityToken = () => {
  return document
    .querySelector("meta[name='csrf-token']")
    .getAttribute('content')
}

export default authenticityToken
